// extracted by mini-css-extract-plugin
export var arrowIcon = "navBtn-module--arrowIcon--rKfgX";
export var btn = "navBtn-module--btn--xzu5B";